import React, { useState, useEffect } from "react";
import { Box, Typography, TextField, Grid, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleAxiosError } from "../../config/action-config";
import { trialUsersTable as tableDef } from "../../config/grid-columns-defs";
import DeleteAlertDialog from "../../component/DeleteAlertDialog";
import CreateDialog from "../../component/CreateDialog";
import { showAlert } from "../../actions/alert";
import { useForm } from "react-hook-form";
import BetterControlledTable from "../../component/BetterControlledTable";
import {
  createTrailUser,
  deleteTrailUser,
  getTrailUser,
} from "../../api/trialUsers";

const emptyTrailUserData = {
  email: "",
  firstname: "",
  lastname: "",
  contact: "",
  address: "",
  company: "",
};

export default function TrialUsers() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const user = useSelector((state) => state.user);
  const dialogAction = useSelector((state) => state.dialog);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [createDialogOpen, setCreateDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(-1);

  const onNewProjectSubmit = (data) => {
    createTrailUser(data, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        reset();
        // setNewEmployeeData(emptyTrailUserData);
        refreshTable();
        setCreateDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setCreateDialogOpen(false);
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DELETE":
        setDeleteDialogOpen(true);
        break;
      case "VIEW":
        dispatch({ type: "" });
        navigate(`${dialogAction.data.id}`);
        break;
      default:
        break;
    }
  }, [dialogAction]);

  useEffect(() => {
    if (deleteId === -1) return;
    deleteTrailUser(deleteId, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeleteId(-1);
        refreshTable();
        setDeleteDialogOpen(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
        setDeleteId(-1);
        setDeleteDialogOpen(false);
      });
  }, [deleteId]);

  useEffect(() => {
    if (!createDialogOpen) {
      reset();
      // setNewEmployeeData(emptyTrailUserData);
    }
  }, [createDialogOpen]);

  const [queryFilters, setQueryFilters] = useState({ email: "", company: "" });
  function onQueryFilterChange({ target }) {
    const { name, value } = target;
    setQueryFilters((prev) => ({ ...prev, [name]: value }));
  }
  const [trailUserTableRefreshCount, setTrailUserTableRefreshCount] =
    useState(0);
  async function getTrialUserTableData(limit, offset) {
    try {
      const { data } = await getTrailUser(
        { limit, offset, ...queryFilters },
        user.token
      );

      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  function refreshTable(e) {
    e?.preventDefault();
    setTrailUserTableRefreshCount((prev) => prev + 1);
  }

  return (
    <Box className="pmt-container-box">
      <Box className="pmt-title-box">
        <Box className="typography-title">
          <Typography variant="h1" className="pmt-headings-h1">
            Trial Users
          </Typography>
        </Box>
        <Button
          variant="contained"
          style={{ padding: "5px 7px" }}
          onClick={() => {
            setCreateDialogOpen(true);
          }}
        >
          Add Trial User
        </Button>
      </Box>
      <br />
      <Box
        component="form"
        onChange={refreshTable}
        // sx={{ px: 2, pb: 2, display: "flex", columnGap: 1 }}

        className="pmt-filter-box"
      >
        <Grid
          container
          className="report-filter-box"
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 1, md: 1 }}
        >
          <Grid item md={3} sm={4} xs={12}>
            <TextField
              size="small"
              label="Email"
              name="email"
              value={queryFilters.email}
              onChange={onQueryFilterChange}
              fullWidth
            />
          </Grid>
          {/* <div style={{ width: 10 }}></div> */}
          <Grid item md={3} sm={4} xs={12}>
            <TextField
              size="small"
              label="Company"
              name="company"
              value={queryFilters.company}
              onChange={onQueryFilterChange}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* <Button variant="contained" size="small" type="submit" >Search</Button> */}
      </Box>
      <div className="pmt-main-table">
        <BetterControlledTable
          hasActionButtons={false}
          getTableRows={getTrialUserTableData}
          columns={tableDef}
          perPage={10}
          refreshCounter={trailUserTableRefreshCount}
        />
      </div>
      <DeleteAlertDialog
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        setDeleteId={setDeleteId}
        rowId={dialogAction.data?.id}
      />

      <CreateDialog
        open={createDialogOpen}
        setOpen={setCreateDialogOpen}
        onSubmit={handleSubmit(onNewProjectSubmit)}
      >
        <form onSubmit={handleSubmit(onNewProjectSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="email"
                fullWidth
                label="Email"
                type="email"
                inputRef={register({
                  required: "Email Address  is required.",
                  pattern: {
                    value:
                      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                    message: "Please enter a valid e-mail address.",
                  },
                })}
                required
                error={Boolean(errors.email)}
                helperText={errors.email?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="firstname"
                fullWidth
                label="First Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                inputRef={register({
                  required: "First Name is required.",
                })}
                required
                error={Boolean(errors.firstname)}
                helperText={errors.firstname?.message}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="lastname"
                fullWidth
                label="Last Name"
                className="name-textfeild"
                type="text"
                variant="outlined"
                // inputRef={register({
                //   required: false,
                // })}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="contact"
                fullWidth
                inputProps={{ maxLength: 10 }}
                label="Contact"
                type="tel"
                // inputRef={register({
                //   required: "Contact Number is required.",
                //   validate: (value) =>
                //     value.length > 9 || "Please enter a valid number",
                // })}
                // required
                error={Boolean(errors.contact)}
                helperText={errors.contact?.message}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6}>
              <TextField
                margin="dense"
                name="company"
                fullWidth
                label="Company"
                // inputRef={register({
                //   required: "Company is required.",
                // })}
                // required
                error={Boolean(errors.company)}
                helperText={errors.company?.message}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <TextField
                margin="dense"
                name="address"
                fullWidth
                label="Address"
                type="text"
                variant="outlined"
                // inputRef={register({
                //   required: "Address is required.",
                // })}
                // required
                error={Boolean(errors.address)}
                helperText={errors.address?.message}
              />
            </Grid>
          </Grid>
        </form>
      </CreateDialog>
    </Box>
  );
}
